<template>
  <div id="app">
    <div class="header-container">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-narrow is-hidden-mobile">
            <div id="bob-ross">
              <router-link to="/paintings">
                <img src="./assets/bob-ross.png">
              </router-link>
            </div>
          </div>
          <div class="column has-text-centered is-offset-1-desktop">
            <h1 class="title is-1">
              <router-link to="/paintings">
                Bob Ross Experience
              </router-link>
            </h1>
          </div>
          <div class="column is-narrow" style="align-self: flex-end">
            <div class="attribution has-text-centered has-text-right-desktop">
              Just for fun by <a href="http://agibbons.com">Adam Gibbons</a>
              <br>
              Code on <a href="https://github.com/adamgibbons/bob-ross">Github</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'BobRoss'
}
</script>

<style>
  html, body {
    background-color: #333;
  }
  .title {
    font-family: 'Permanent Marker', cursive;
  }
  .title, .content, div, p {
    color: white;
  }
  .header-container {
    font-family: 'Permanent Marker', cursive;
    background: #555;
    font-size: 2em;
    padding-top: .33em;
    margin-bottom: 1em;
  }
  .header-container a {
    color: white;
    background: transparent;
  }
  .header-container a:hover {
    color: white;
    background: transparent;
  }
  #bob-ross {
    width: 3.33em;
    position: absolute;
    margin: .1em .2em 3em .5em;
    opacity: 9;
  }
  #bob-ross img {
    width: 100%;
    max-height: unset;
    animation-name: doTheBob;
    animation-duration: 20s;
    animation-delay: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes doTheBob {
    0% {
      transform: rotate(0deg) scale(1);
    }
    2% {
      transform: rotate(-6deg) scale(1.2);
    }
    4% {
      transform: rotate(0deg) scale(1);
    }

    20% {
      transform: rotate(-1deg);
    }
    21% {
      transform: rotate(3deg);
    }
    22% {
      transform: rotate(-5deg);
    }
    23% {
      transform: rotate(7deg);
    }
    24% {
      transform: rotate(-5deg);
    }
    25% {
      transform: rotate(3deg);
    }
    26% {
      transform: rotate(-2deg);
    }
    27% {
      transform: rotate(1deg);
    }
    28% {
      transform: rotate(0deg);
    }

    78% {
      transform: rotate(0deg) scale(1);
    }
    80% {
      transform: rotate(-3deg) scale(.8);
    }
    82% {
      transform: rotate(0deg) scale(1);
    }
  }
  .attribution {
    font-weight: 600;
    font-family: sans-serif;
    font-size: .45em;
  }
  .attribution a {
    color: orange;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue